enum ButtonVariantEnum {
  PRIMARY = 'primary',
  DANGER = 'danger',
  LINK = 'link',
  LINK_DANGER = 'link-danger',
  SUCCESS = 'success',
  WARNING = 'warning',
}

export default ButtonVariantEnum;
